import ExportFooterStatus from './ExportFooterStatus';
import ExportTourOperatorLogo from './ExportTourOperatorLogo';

export default function ExportPageFooter({
  trip,
  tourOperator,
  settings,
  status = false,
}) {
  const logo = (
    <div className="flex-shrink-0 opacity-70">
      <ExportTourOperatorLogo tourOperator={tourOperator} compact />
    </div>
  );

  if (!status) return <div className="flex justify-end">{logo}</div>;

  return (
    <div className="flex items-end justify-between gap-4 border-t border-k-gray/40 pt-2">
      <ExportFooterStatus trip={trip} settings={settings} />
      {logo}
    </div>
  );
}
